export const SET_SELECTED_VENUE= 'SET_SELECTED_VENUE'
export const SET_SELECTED_VENUE_SUCCESS= 'SET_SELECTED_VENUE_SUCCESS'
export const SET_SELECTED_VENUE_ERROR='SET_SELECTED_VENUE_ERROR'

export const SetSelectedVenue= (data) => ({
    type: SET_SELECTED_VENUE,
    payload: data
})